import {
  getLoveNeedsGraphs,
  getOtherPersonalityGraphs,
  getPersonalityGraphs,
} from 'affiny-core/helpers/personalityReport';
import { IPersonalityReportGraph } from 'affiny-core/modules/personalityReport/types';
import { Box, Flex, Grid, rem } from 'affiny-ui/src';
import React, { memo, useState } from 'react';
import { PersonalityReportLayerBottomChapterNavigation } from './PersonalityReportLayerBottomChapterNavigation';
import PersonalityReportLayerPersonalitySubChapter from './PersonalityReportLayerPersonalitySubChapter';
import { PersonalityReportLayerPersonalityBehevior } from './PersonalityReportLayerPersonalityBehevior';
import { PersonalityReportLayerPersonalitySubMenu } from './PersonalityReportLayerPersonalitySubMenu';

interface IPersonalityReportLayerPersonalityChapter {
  graphs: IPersonalityReportGraph[];
  personalityIntroAnalysis: string[];
  setSection: (arg: string) => void;
}

export const PersonalityReportLayerPersonalityChapter = memo(
  ({
    graphs,
    personalityIntroAnalysis,
    setSection,
  }: IPersonalityReportLayerPersonalityChapter) => {
    const loveNeedsGraphs = getLoveNeedsGraphs(graphs);
    const personalityGraphs = getPersonalityGraphs(graphs);
    const otherGraphs = getOtherPersonalityGraphs(graphs);
    const [activeTitle, setActiveTitle] = useState(loveNeedsGraphs[0].id);

    const subMenuGraphs = [
      {
        tradKey: `detailedPages.${loveNeedsGraphs[0].id}.title`,
        id: loveNeedsGraphs[0].id,
      },
      { tradKey: 'behaviourProfile.title', id: 'behaviourProfile' },
      {
        tradKey: `detailedPages.${personalityGraphs[0].id}.title`,
        id: personalityGraphs[0].id,
      },
      ...otherGraphs.map(element => ({
        tradKey: `detailedPages.${element.id}.title`,
        id: `${element.id}`,
      })),
    ];

    return (
      <Box>
        <Grid height="100%">
          <Flex gridColumn="span 4" flexDirection="column">
            <Box position="sticky" top={rem(161)}>
              <PersonalityReportLayerPersonalitySubMenu
                graphs={subMenuGraphs}
                nbOfItem={subMenuGraphs.length - 1}
                activeTitle={activeTitle}
              />
            </Box>
          </Flex>
          <Flex gridColumn="span 8" flexDirection="column">
            <Box>
              <PersonalityReportLayerPersonalitySubChapter
                graphs={loveNeedsGraphs}
                personalityIntroAnalysis={personalityIntroAnalysis}
                setTitle={setActiveTitle}
              />
              <PersonalityReportLayerPersonalityBehevior
                setTitle={setActiveTitle}
              />
              <PersonalityReportLayerPersonalitySubChapter
                graphs={personalityGraphs}
                setTitle={setActiveTitle}
              />
              {otherGraphs.map((otherGraphs, idx) => (
                <PersonalityReportLayerPersonalitySubChapter
                  key={idx}
                  graphs={[otherGraphs]}
                  setTitle={setActiveTitle}
                />
              ))}
            </Box>
            <PersonalityReportLayerBottomChapterNavigation
              chapter="personality"
              setSection={setSection}
            />
          </Flex>
        </Grid>
      </Box>
    );
  }
);
